module.exports = __webpack_public_path__ + "img/homeimage5.6e5cc5ed.png";